

















import Vue from 'vue'
import SectionTitle from '@/components/SectionTitle.vue'
const ServiceScens = Vue.extend({
  // 类型推断已启用
  components: {
    SectionTitle
  },
  computed: {
    scenes () {
      return [
        {
          id: 1,
          imgUrl: require('@/assets/image/index/scenes/s1.png'),
          flag: this.$t('business.scenesT1'),
          details: this.$t('business.scenesD1')
        },
        {
          id: 2,
          imgUrl: require('@/assets/image/index/scenes/s2.png'),
          flag: this.$t('business.scenesT2'),
          details: this.$t('business.scenesD2')
        },
        {
          id: 3,
          imgUrl: require('@/assets/image/index/scenes/s3.png'),
          flag: this.$t('business.scenesT3'),
          details: this.$t('business.scenesD3')
        },
        {
          id: 4,
          imgUrl: require('@/assets/image/index/scenes/s4.png'),
          flag: this.$t('business.scenesT4'),
          details: this.$t('business.scenesD4')
        },
        {
          id: 5,
          imgUrl: require('@/assets/image/index/scenes/s5.png'),
          flag: this.$t('business.scenesT5'),
          details: this.$t('business.scenesD5')
        },
        {
          id: 6,
          imgUrl: require('@/assets/image/index/scenes/s6.png'),
          flag: this.$t('business.scenesT6'),
          details: this.$t('business.scenesD6')
        },
        {
          id: 7,
          imgUrl: require('@/assets/image/index/scenes/s7.png'),
          flag: this.$t('business.scenesT7'),
          details: this.$t('business.scenesD7')
        },
        {
          id: 8,
          imgUrl: require('@/assets/image/index/scenes/s8.png'),
          flag: this.$t('business.scenesT8'),
          details: this.$t('business.scenesD8')
        }
      ]
    }
  }
})

export default ServiceScens
